"use strict";

exports.__esModule = true;
var _ElevateSettingsMenu = require("./ElevateSettingsMenu");
Object.keys(_ElevateSettingsMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElevateSettingsMenu[key]) return;
  exports[key] = _ElevateSettingsMenu[key];
});